import TransactionListPage from './TransactionListPage';

export default TransactionListPage;
